import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "@user/components/Header";
import Footer from "@user/components/Footer";
import { PricingSection } from "@user/components/home/PricingSection";

export default function Pricing() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAFAFA] flex flex-col">
      <Header />
      <main className="flex-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
          <div className="mb-6">
            <span className="adv-chip">Transparent Fees</span>
            <h1
              className="mt-3 text-3xl sm:text-4xl font-extrabold text-[#0A2540]"
              style={{ fontFamily: "Poppins" }}
            >
              Simple, Transparent Pricing
            </h1>
            <p className="mt-2 text-slate-600 max-w-2xl">
              No hidden fees · Pay per consultation · GST included.
            </p>
          </div>
          <PricingSection
            ctaLabel="Consult Now"
            onCta={() => navigate("/lawyers")}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
}
